import { useAudio, useAudioTime } from "@aircall/tractor";
import { NetworkStatus } from "@apollo/client";
import { useEffect, useRef } from "react";
import { useAudioUrlQuery } from "@/hooks/useAudioUrlQuery/useAudioUrlQuery";
import { QueryOptions } from "@/hooks/useAudioUrlQuery/useAudioUrlQuery.decl";
import { shouldFetchSrc } from "./Player.utils";

export function useAudioUrlExpired() {
  const retryCount = useRef(0);
  const lastKnownTime = useRef(0);
  const queryOptions: QueryOptions = {
    fetchPolicy: "cache-only",
    notifyOnNetworkStatusChange: true,
  };
  const { refetch, networkStatus } = useAudioUrlQuery(queryOptions);

  const { error, seek, play } = useAudio();
  const { currentTime } = useAudioTime();

  const updateSrc = async () => {
    retryCount.current++;
    // Save last known time BEFORE refetching
    lastKnownTime.current = currentTime;
    await refetch();
    // Restore playback position using the saved time
    setTimeout(() => {
      seek(lastKnownTime.current);
      play();
    }, 0);
  };

  useEffect(() => {
    if (shouldFetchSrc(error, retryCount.current)) {
      updateSrc();
    }
  }, [error, refetch, retryCount]);

  return { isLoading: networkStatus === NetworkStatus.refetch };
}
